import { api } from '@/plugins/api';

const getDefaultState = () => {
	return {
		documentsTextes: []
	}
}

const getDefaultValue = () => {
	return {
		label: "",
		typeDocumentId: 0,
		descriptif: "",
	}
}

const state = getDefaultState()

const getters = {
	getDocumentsTextes: (state) => { return state.documentsTextes }
}

const mutations = {
	setDocumentsTextes (state, dto) {
		state.documentsTextes = dto ?? []
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async fetchDocumentsTextes ({ state, commit }) {
		if (state.documentsTextes.length > 0) {
			return
		}
		
		const response = await api.get(`parametrages/documents/textes/`)
		commit("setDocumentsTextes", response.data)
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})